<template>
  <div style="height: 100%">
    <UiMain v-if="$route.path !== '/login'">
      <loading ref="loading"></loading>
      <router-view></router-view>
    </UiMain>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import UiMain from '@/components/base/ui/UiMain.vue';
import Loading from "@/components/system/Loading.vue";

export default {
  components: {Loading, UiMain},
};
</script>
